import React, { Component } from 'react'
import PropTypes from 'prop-types'
import './../../ui.style.scss'
import MetaDefaultDropDown from '../inputs/MetaDefaultDropDown'
import InputNumber from '../inputs/InputNumber'
import InputCustom from '../inputs/InputCustom'
import Accordion from '../../dataDisplay/Accordion'
import { message, Skeleton, Switch, Tooltip } from 'antd'
import _, { isEmpty } from 'lodash'
import InformationIcon from '../../general/icons/InformationIcon'
import CustomMetaRichTextModal from './CustomMetaRichTextModal'
import RichText from 'components/ui/dataEntry/other/RichText'
import DateTimePicker from 'components/ui/dataEntry/inputs/DatePicker'
import moment from 'moment'
import { DATE_TIME_TYPE, FILE_TYPE, RICH_TEXT_TYPE } from 'constants/general-constants'
import CustomMetaFileModal from './CustomMetaFileModal'
import AddIcon from 'components/ui/general/icons/AddIcon'
import CustomMetaFileTypeIcon from './CustomMetaFileTypeIcon'
// import Input from 'components/ui/dataEntry/inputs/Input'
// import CopyLinkButton from 'components/ui/general/buttons/CopyLinkButton'
// import ViewPageIcon from 'components/ui/general/icons/ViewPageIcon'

class CreateMetaComponent extends Component {
  constructor (props) {
    super(props)
    this.state = {
      metaFieldArray: null,
      isRichTextEditorModalOpen: {},
      destroyRichTextModal: false,
      isCustomMetaRichTextModalOpen: {}
    }
  }

  richTextEditorModalHandler = (metaItem, flag) => {
    this.setState(prevState => {
      return {
        isRichTextEditorModalOpen: {
          ...prevState.isRichTextEditorModalOpen,
          [metaItem]: flag
        }
      }
    })
  }

  getAssetMetaFields = (metaData, meta, index, assetId, showInfoIcon, mainIndex) => {
    const { isRichTextEditorModalOpen, destroyRichTextModal, isCustomMetaRichTextModalOpen } = this.state
    const { handleMetaDetailsChange } = this.props
    const selectedMeta = (metaData || []).find(item => item.displayName === meta.displayName && item.type === meta.type)
    if (meta.type === 'BOOLEAN') {
      return <div className='switch-container input-field' key={index}>
        <div className='switch-inner-container'>
          <span>{meta.displayTitle || meta.displayName} </span>
          {
            meta.tooltip &&
            <Tooltip placement='right' title={meta.tooltip} >
              <span className='asset-info-icon-boolean'><InformationIcon /></span>
            </Tooltip>
          }
          <Switch checked={selectedMeta ? (selectedMeta.value === 'false' ? false : selectedMeta.value) : false} onChange={(value) => handleMetaDetailsChange(meta, value)} />
        </div>
      </div>
    } else if (meta.type === 'STRING') {
      if (meta.values && !isEmpty(meta.values)) {
        return <div className='input-field'>
          <label className='input-title'>{meta.displayTitle || meta.displayName} {meta.isRequired ? <span className='mandatory'>*</span> : ''}</label>
          {
            meta.tooltip &&
            <Tooltip placement='right' title={meta.tooltip} >
              <span className='asset-info-icon'><InformationIcon /></span>
            </Tooltip>
          }
          <MetaDefaultDropDown
            key={index}
            title={meta.displayTitle || meta.displayName}
            options={meta.values}
            meta={meta}
            placeholder={`Select ${meta.displayTitle || meta.displayName}`}
            inputName='title'
            isRequired={meta.isRequired}
            selectedValue={selectedMeta && selectedMeta.value ? [selectedMeta.value] : []}
            handleChange={handleMetaDetailsChange}
            isError={selectedMeta ? selectedMeta.isError : false}
            assetId={assetId}
            parentCompoent='asset-container'
            mode={'default'}
            allowClear
          />
        </div>
      } else {
        return <InputCustom
          key={index}
          tooltip={meta.tooltip}
          title={meta.displayTitle || meta.displayName}
          placeholder={`Enter ${meta.displayTitle || meta.displayName}`}
          inputName='title'
          isRequired={meta.isRequired}
          value={selectedMeta ? selectedMeta.value : ''}
          handleChange={({ target }) => handleMetaDetailsChange(meta, target.value)}
          isError={selectedMeta ? selectedMeta.isError : false}
          errorMessage={`${meta.displayTitle || meta.displayName} is a mandatory field`}
        />
      }
    } else if (meta.type === 'INTEGER') {
      return <InputNumber
        limit={16}
        key={index}
        tooltip={meta.tooltip}
        title={meta.displayTitle || meta.displayName}
        placeholder={`Enter ${meta.displayTitle || meta.displayName}`}
        inputName='title'
        isRequired={meta.isRequired}
        value={selectedMeta ? parseInt(selectedMeta.value) : 0}
        handleChange={(value) => handleMetaDetailsChange(meta, value)}
        isError={selectedMeta ? selectedMeta.isError : false}
        errorMessage={`${meta.displayTitle || meta.displayName} is a mandatory field`}
      />
    } else if (meta.type === 'LIST') {
      return <div className='input-field' id='input-field'>
        <label className='input-title'>{meta.displayTitle || meta.displayName}
          {meta.isRequired ? <span className='mandatory'>*</span> : ''}</label>
        {
          meta.tooltip &&
          <Tooltip placement='right' title={meta.tooltip} >
            <span className='asset-info-icon'><InformationIcon /></span>
          </Tooltip>
        }
        <MetaDefaultDropDown
          key={index}
          title={meta.displayTitle || meta.displayName}
          options={meta.values}
          meta={meta}
          placeholder={`Select ${meta.displayTitle || meta.displayName}`}
          inputName='title'
          isRequired={meta.isRequired}
          selectedValue={selectedMeta ? selectedMeta.fieldValues : []}
          handleChange={handleMetaDetailsChange}
          isError={selectedMeta ? selectedMeta.isError : false}
          errorMessage={''}
          assetId={assetId}
          parentCompoent='asset-container'
        />
      </div>
    } else if (meta.type === RICH_TEXT_TYPE.value) {
      return (
        <div className='rich-text-custom-meta-field-wrapper'>
          <div className='rich-text-input-wrapper' >
            <label className='input-title'>{meta.displayTitle || meta.displayName} {meta.isRequired ? <span className='mandatory'>*</span> : ''}</label>
            {
              meta.tooltip &&
              <Tooltip placement='right' title={meta.tooltip} >
                <span className='asset-info-icon'><InformationIcon /></span>
              </Tooltip>
            }
            <RichText
              wrapperClassName='asset-details-text-editor'
              id={`richtext-editor-clone-create-meta-${mainIndex}-${index}`}
              text={selectedMeta?.value || null}
              onRichTextChange={value => {
                // handleMetaDetailsChange(meta, value)
              }}
              showCloseIcon={false}
              onWrapperClick={(e) => {
                const clickedElement = e.target
                if (!clickedElement?.classList.contains('ql-container')) {
                  this.setState({ destroyRichTextModal: false }, () => this.richTextEditorModalHandler(meta.id, true))
                }
              }}
              readOnly
            />
          </div>
          {
            !destroyRichTextModal &&
            <CustomMetaRichTextModal
              title={`${meta.displayTitle || meta.displayName || RICH_TEXT_TYPE.name}  - details`}
              visible={isRichTextEditorModalOpen?.[meta?.id]}
              onCancel={() => this.richTextEditorModalHandler(meta.id, false)}
              onOk={() => this.richTextEditorModalHandler(meta.id, false)}
              onChange={(value) => handleMetaDetailsChange(meta, value)}
              value={selectedMeta?.value}
              id={`richtext-editor-original-create-meta-${mainIndex}-${index}`}
              afterClose={() => {
                this.setState({
                  destroyRichTextModal: true
                })
              }}
            />
          }
        </div>
      )
    } else if (meta.type === DATE_TIME_TYPE.value) {
      return <div className='input-field'>
        <label className='input-title'>{meta.displayTitle || meta.displayName} {meta.isRequired ? <span className='mandatory'>*</span> : ''}</label>
        {
          meta.tooltip &&
          <Tooltip placement='right' title={meta.tooltip} >
            <span className='asset-info-icon'><InformationIcon /></span>
          </Tooltip>
        }
        <DateTimePicker
          use12Hours={false}
          date={selectedMeta?.value
            ? moment(selectedMeta.value)
            : null
          }
          dateFormat='DD MMM YYYY, hh:mm A'
          onChange={(value) => handleMetaDetailsChange(meta, value)}
          placeholder='Select Date time'
          // disabledTime={endDate ? () => this.disabledRangeTime('end') : () => this.disableTimeComplete()}
          // disabledDate={this.disableEndDate}
          // onOpenChange={(value) => this.onOpenChange(value, false)}
          status={selectedMeta?.isError ? 'error' : ''}
        />
      </div>
    } else if (meta.type === FILE_TYPE.value) {
      const folderIdList = meta?.supportedFileTypes || []
      const value = selectedMeta?.file?.fileName
      const isModalOpen = isCustomMetaRichTextModalOpen[meta.id] === true
      return (
          <>
            <CustomMetaFileModal
              title='Select File'
              project={this.props.project}
              visible={isModalOpen}
              onOk={(selectedItem) => {
                const fileName = selectedItem?.fileName
                if (!fileName) {
                  message.error('Please select a valid file')
                }
                this.setState({ isCustomMetaRichTextModalOpen: {} })
                handleMetaDetailsChange(meta, selectedItem)
              }}
              onCancel={() => {
                this.setState({
                  isCustomMetaRichTextModalOpen: {}
                })
              }}
              rootFolderItemsToShow={folderIdList}
            />

            <div className='input-field file-input-wrapper'>
              {
                value
                  ? (
                    <CustomMetaFileTypeIcon
                      fileName={value}
                      onClear={() => handleMetaDetailsChange(meta, '')}
                      meta={{
                        customMetaLabel: meta.displayTitle || meta.displayName,
                        customMetaToolTip: meta.tooltip
                      }}
                      fileNameToolTipPlacement='right'
                    />
                  )
                  : (
                    <div
                      className='file-input not-selected'
                      onClick={() => {
                        this.setState({
                          isCustomMetaRichTextModalOpen: {
                            ...this.state.isCustomMetaRichTextModalOpen,
                            [meta.id]: true
                          }
                        })
                      }}
                    >
                      <div className='label-wrapper'>
                        <label>
                          {meta.displayTitle || meta.displayName}
                        </label>
                        {
                          meta.tooltip &&
                          <Tooltip placement='right' title={meta.tooltip} >
                            <span className='asset-info-icon-boolean'><InformationIcon /></span>
                          </Tooltip>
                        }
                      </div>
                      <div className='details-wrapper'>
                        <label>  {folderIdList.join(', ')} </label>
                        <span className='add-icon'>
                          <AddIcon color='#AFAFAF' />
                        </span>
                      </div>
                    </div>
                  )
              }

            </div>

            {/* <div className='input-field file-input'>
              <label>
                {meta.displayTitle || meta.displayName}
                {meta.isRequired ? <span className='mandatory'>*</span> : ''}
              </label>
              <div className='wrapper'>
                <div
                  onClick={() => {
                    this.setState({
                      isCustomMetaRichTextModalOpen: {
                        ...this.state.isCustomMetaRichTextModalOpen,
                        [meta.id]: true
                      }
                    })
                  }}
                  className='input-wrapper'
                  title={value}
                >
                  <Input
                    title={null}
                    placeholder='Upload File'
                    readOnly
                    className='full-width'
                    noLabel
                    value={value}
                  />
                </div>
                <div className='icon-wrapper'>
                  <Tooltip placement='top' title='Copy URL'>
                    <span
                      onClick={() => {
                        const textField = document.createElement('textarea')
                        textField.innerText = value
                        document.body.appendChild(textField)
                        textField.select()
                        document.execCommand('copy')
                        textField.remove()
                        message.success(userMessages.FILE_LINK_COPIED)
                      }}
                    >
                      <CopyLinkIcon
                        color={'red'}
                      />
                    </span>
                  </Tooltip>
                  <Tooltip placement='top' title='Preview File'>
                    <span>
                      <ViewPageButton
                        onClick={() => {
                          window.open(value, '_blank').focus()
                        }}
                        isDisabled={isEmpty(value)}
                        iconColor='#424A52'
                      />
                    </span>
                  </Tooltip>
                  <Tooltip placement='top' title='Clear Field'>
                    <div
                      className='clear-icon'
                      onClick={() => handleMetaDetailsChange(meta, '')}
                    >
                      <CrossIcon
                        onClick={() => handleMetaDetailsChange(meta, '')}
                      />
                    </div>
                  </Tooltip>
                </div>
              </div>
            </div> */}
          </>
      )
    }
  }

  UNSAFE_componentWillReceiveProps () { // eslint-disable-line camelcase
    if (this.props.assetConfig && this.props.assetConfig.metaFields) {
      const arrayOfArrays = _.groupBy(this.props.assetConfig.metaFields, item => (item.section ? item.section.id : null))
      this.setState({ metaFieldArray: arrayOfArrays })
    }
  }

  render () {
    const { details, width } = this.props
    const { metaFieldArray } = this.state
    return (
      <>
        {
          metaFieldArray ? Object.keys(metaFieldArray).map((key, mainIndex) => {
            const value = metaFieldArray[key]
            if (key === 'null') return null
            return (
              <Accordion
                title={value[0].section.title}
                childComponent={
                  <Skeleton active avatar={false} title={false} paragraph={{ rows: 10, width: width }}
                    loading={this.props.isLoading}>
                    <div className='general-details' id={`general-details-${mainIndex}`}>
                      {
                        value.map((item, index) => this.getAssetMetaFields(details.meta, item, index, details.id, null, mainIndex))
                      }
                    </div>
                  </Skeleton>
                }
              />
            )
          }) : null
        }

      </>
    )
  }
}

CreateMetaComponent.propTypes = {
  /** Details of list ratings */
  listRatingDetails: PropTypes.array,
  /** Details of asset ratings */
  ratings: PropTypes.array
  /** function to handle rating change */
}

CreateMetaComponent.defaultProps = {
}

export default CreateMetaComponent
